export default "__VITE_ASSET__BWKUUA2x__"